import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  moveLeft,
  moveRight,
  moveUp,
  moveDown,
  checkIsDragging
} from "../../../actions";
import Layer from "./Layer";
import ColorMask from "./ColorMask";
import watermark from "../../../images/watermark.png";

class Layers extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPress, false);
  }

  handleKeyPress = (event) => {
    if (event.key === "ArrowLeft") {
      this.props.moveLeft();
    }
    if (event.key === "ArrowRight") {
      this.props.moveRight();
    }
    if (event.key === "ArrowUp") {
      this.props.moveUp();
    }
    if (event.key === "ArrowDown") {
      this.props.moveDown();
    }
  };

  handleIsDragging = (isDragging, isSelected) => {
    this.props.checkIsDragging({ isDragging, isSelected });
  };

  render() {
    if (this.props.design) {
      const layers = this.props.design.layer_set;
      const layersList = layers.map((layer) => {
        return (
          <Layer
            key={layer.layer_id}
            layer={layer}
            design={this.props.design}
            disableInteractivity={this.props.disableInteractivity}
            guidesVisible={this.props.guidesVisible}
            bleed={this.props.bleed}
            onShow2ndTip={this.props.onShow2ndTip}
            didShow2ndTip={this.props.didShow2ndTip}
            handleHide2ndTip={this.props.handleHide2ndTip}
            handleIsDragging={this.handleIsDragging}
            isDraggingSelected={this.props.isDraggingSelected}
          />
        );
      });

      const maskList = layers.map((layer) => {
        return <ColorMask key={layer.layer_id} layer={layer} />;
      });

      const hasUploadedArt =
        layers.filter(
          (layer) =>
            layer.image_elements.filter((image) => image.type === "art")
              .length > 0
        ).length > 0;

      return (
        <div className="layers__container">
          {!hasUploadedArt ? (
            <img className="watermark" src={watermark} alt="Watermark" />
          ) : null}
          {layersList}
          {maskList}
        </div>
      );
    } else {
      return <h1>Layers</h1>;
    }
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    bleed: state.bleed,
    isDragging: state.isDragging.isDragging,
    isDraggingSelected: state.isDragging.isSelected
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      moveLeft,
      moveRight,
      moveUp,
      moveDown,
      checkIsDragging
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Layers);
